import myDashboard from '@/api/report/myDashboard'
import portlets from '@/api/report/portlets'
import manuals from '@/api/report/manuals'
import manualArticles from '@/api/report/manualArticles'

export default {
  myDashboard,
  portlets,
  manuals,
  manualArticles,
}
